export default __webpack_public_path__ + "static/media/info.1ac5aa95.svg";